import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Linkedin } from "lucide-react";

export default function Footer() {
  return (
    <footer style={{ background: "#0c1a3d" }} className="text-white mt-24">
      <div className="max-w-7xl mx-auto px-6 pt-20 pb-10">
        <div className="grid md:grid-cols-3 gap-12 md:gap-16 items-start">
          {/* Logo + tagline + socials */}
          <div className="md:col-span-1">
            <Link to="/" className="inline-block">
              <img
                src="/images/somm-logo.png"
                alt="Somm.ai"
                className="h-14 md:h-16 w-auto object-contain"
              />
            </Link>
            <p className="mt-6 text-white/70 text-[15px] leading-relaxed max-w-sm">
              Leverage the world&apos;s largest updating database of wine and spirits lists to improve on-premise sales.
            </p>
            <div className="flex items-center gap-3 mt-6">
              <a
                href="https://www.instagram.com/somm.pro/"
                target="_blank"
                rel="noreferrer"
                aria-label="Instagram"
                className="w-10 h-10 rounded-md border border-white/20 flex items-center justify-center hover:bg-white/10 transition-colors"
              >
                <Instagram size={16} />
              </a>
              <a
                href="https://www.linkedin.com/company/somm-ai/"
                target="_blank"
                rel="noreferrer"
                aria-label="LinkedIn"
                className="w-10 h-10 rounded-md border border-white/20 flex items-center justify-center hover:bg-white/10 transition-colors"
              >
                <Linkedin size={16} />
              </a>
            </div>
          </div>

          {/* Nav columns */}
          <div className="md:col-span-2 grid grid-cols-2 sm:grid-cols-3 gap-8">
            <div>
              <div className="text-sm font-semibold uppercase tracking-wider text-white/60 mb-5">Product</div>
              <ul className="space-y-3 text-[15px]">
                <li><Link to="/" className="text-white hover:opacity-80 transition-opacity">Home</Link></li>
                <li><Link to="/pricing" className="text-white hover:opacity-80 transition-opacity">Pricing</Link></li>
                <li><Link to="/contact" className="text-white hover:opacity-80 transition-opacity">Contact</Link></li>
              </ul>
            </div>
            <div>
              <div className="text-sm font-semibold uppercase tracking-wider text-white/60 mb-5">Account</div>
              <ul className="space-y-3 text-[15px]">
                <li>
                  <a href="https://app.somm.ai/" target="_blank" rel="noreferrer" className="text-white hover:opacity-80 transition-opacity">Login</a>
                </li>
                <li>
                  <a href="https://www.somm.ai/meeting" target="_blank" rel="noreferrer" className="text-white hover:opacity-80 transition-opacity">Demo</a>
                </li>
              </ul>
            </div>
            <div>
              <div className="text-sm font-semibold uppercase tracking-wider text-white/60 mb-5">Legal</div>
              <ul className="space-y-3 text-[15px]">
                <li>
                  <Link to="/policies" className="text-white hover:opacity-80 transition-opacity">Policies</Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col md:flex-row items-center justify-between gap-2 text-sm text-white/70">
          <div>
            &copy; {new Date().getFullYear()} Somm Inc. All rights reserved.
          </div>
          <div>
            Somm.ai is operated by Somm Inc.
          </div>
        </div>
      </div>
    </footer>
  );
}
